import { useRouter } from "next/router";
import { useMemo } from "react";
import { getCarriedQueryParams } from "../../utils/urlParamsAndFilters";

export function useCarriedQueryParams() {
  const router = useRouter();
  return useMemo(() => getCarriedQueryParams(router.query), [router.query]);
}
